import React, { DetailedHTMLProps, HTMLAttributes } from 'react';
import styles from './ModalHeader.module.sass';

const ModalHeader = ({
    children,
    actions, size
}: Props) => {
    return <div className={`${styles['modal__header']} ${styles['modal__header__size--'+(size||'medium')]}`}>
        <div className={styles['modal__header--content']}>
            { children }
        </div>
        { actions && <div className={styles['modal__header-actions']}>
            { actions }
        </div> }
    </div>
}

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>,HTMLDivElement> {
    actions?: any
    size?: 'small' | 'medium'
}

export default ModalHeader;